<!-- 订单评论 -->
<template>
  <div>
    <el-dialog title="订单评论"
               :visible.sync="dialogVisible"
               width="50%"
               :rules="rules"
               :before-close="handleClose">
      <el-form size="small"
               :model="formData"
               class="demo-form-inline"
               ref="formRef">
        <div v-if="formData.source ==1">
          <el-form-item label="商品"
                        label-width="80px"
                        prop="goodsScore">
            <div class="label-list">
              <div>商品是否与描述相符 </div>
              <div style="width: 220px">
                <el-rate :max="5"
                         :show-score="false"
                         :allow-half="false"
                         v-model="formData.goodsScore"
                         show-text
                         :disabled="disabled"
                         :texts="texts"
                         :colors="colors">
                </el-rate>
              </div>
            </div>
          </el-form-item>
          <el-form-item label="物流"
                        label-width="80px"
                        prop="logisticScore">
            <div class="label-list">
              <div>物流是否按时到达</div>
              <div style="width: 220px">
                <el-rate :max="5"
                         :show-score="false"
                         :allow-half="false"
                         v-model="formData.logisticScore"
                         show-text
                         :disabled="disabled"
                         :texts="texts"
                         :colors="colors">
                </el-rate>
              </div>
            </div>
          </el-form-item>
          <el-form-item label="客服"
                        label-width="80px"
                        prop="customerServiceScore">
            <div class="label-list">
              <div>客服回复消息是否及时</div>
              <div style="width: 220px">
                <el-rate :max="5"
                         :show-score="false"
                         :allow-half="false"
                         v-model="formData.customerServiceScore"
                         show-text
                         :disabled="disabled"
                         :texts="texts"
                         :colors="colors">
                </el-rate>
              </div>
            </div>
          </el-form-item>
          <el-form-item label="售后"
                        label-width="80px"
                        prop="afterSalesScore">
            <div class="label-list">
              <div>售后是否积极响应</div>
              <div style="width: 220px">
                <el-rate :max="5"
                         :show-score="false"
                         :allow-half="false"
                         v-model="formData.afterSalesScore"
                         show-text
                         :disabled="disabled"
                         :texts="texts"
                         :colors="colors">
                </el-rate>
              </div>
            </div>
          </el-form-item>
        </div>

        <el-form-item label="评价"
                      :label-width="labelWidth">
          <el-input v-model.trim="formData.comment"
                    type="textarea"
                    :row="2"
                    style="width: 100%"
                    maxlength="200"
                    :disabled="disabled"></el-input>
        </el-form-item>
        <el-form-item label="图片"
                      :label-width="labelWidth">
          <ImgUpload v-model="imageList"
                     :limit="5"
                     :isEdit="disabled"></ImgUpload>
          <div v-if="imageList.length>0">图片格式为jpg或png，图片大小不得超过5M</div>
        </el-form-item>
        <el-form-item label="回复"
                      :label-width="labelWidth">
          <el-input v-model.trim="formData.reply"
                    type="textarea"
                    :row="2"
                    style="width: 100%"
                    maxlength="200"
                    :disabled="disabled"></el-input>
        </el-form-item>
        <el-form-item label="回复图片"
                      :label-width="labelWidth">
          <ImgUpload v-model="replyImageList"
                     :isEdit="disabled"></ImgUpload>
          <!-- <div v-if="replyImageList.length>0">图片格式为jpg或png，图片大小不得超过5M</div> -->
        </el-form-item>
      </el-form>
      <span slot="footer"
            class="dialog-footer"
            v-if="formData.status ==0">
        <el-button @click="submit(false)">驳回</el-button>
        <el-button type="primary"
                   @click="submit(true)">通过</el-button>
      </span>
      <el-image-viewer v-if="showViewer"
                       @close="closeViewer"
                       :url-list="urls" />

    </el-dialog>
  </div>
</template>
<script>
// comInvoiceTitleInfo
import { getCommentById, passOrReject } from "@/api/businessManage";

import ImgUpload from "../imgUpload";
export default {
  components: { ImgUpload },
  props: {
    requestId: {
      type: String,
      default: () => "",
    },

    limit: {
      type: Number,
      default: () => 10,
    },
  },
  computed: {
    headers: function () {
      return {
        Authorization: "Bearer " + getToken(),
      };
    },
  },
  data () {
    return {
      showViewer: false,
      colors: ["#99A9BF", "#F7BA2A", "#FF9900"],
      texts: ["极差", "失望", "一般", "满意", "惊喜"],
      labelWidth: '80px',
      disabled: true,
      action: process.env.VUE_APP_BASE_API + "/product/goodsbase/upload",
      dialogVisible: false,
      imageList: [],
      replyImageList: [],
      formData: {
        comment: "", id: '',
        orderCode: ''
      }, //评论内容
      rules: {
        ruleName: [{ required: true, message: "请输入评价", trigger: "blur" }],
      },
    };
  },
  methods: {
    handleClose () {
      this.dialogVisible = false;
    },
    init () {

    },
    submit (status) {
      this.$confirm((status ? `此操作将【通过】订单评论` : `此操作将【驳回】订单评论`) + ',是否确认操作?', '提示', {
        confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning'
      }).then(() => {
        this.commnetAudit(status)
      }).catch(() => {
        this.$message.warning('您已取消操作');
      });
    },

    commnetAudit (status) {
      passOrReject({ pass: status, id: this.formData.id }).then((res) => {
        if (res.code == 0) {
          this.$message.success('提交成功')
          this.dialogVisible = false;
          this.$emit('get-list')
        } else {
          this.$message.error(res.msg)
          this.handleClose()
          this.$emit('get-list')
        }
      }).catch((err) => {
        console.log(err)
        this.$message.error(err.msg)
        this.handleClose()
      })
    },

    // 查询详情
    getDetail (row) {
      getCommentById({
        id: row.id
      }).then((res) => {
        console.log(res)
        if (res.code == 0) {
          this.formData = res.data;
          if (res.data.image) {
            this.imageList = res.data.image.split(',')
          } else {
            this.imageList = []
          }
          if (res.data.replyImage) {
            this.replyImageList = res.data.replyImage.split(',')
          } else {
            this.replyImageList = []
          }
        }
      }).catch((err) => {
      })
    },

    handleRemove (file, fileList) {
      console.log(file, fileList);
    },
    handlePreview (file) {
      console.log(file);
    },
    handleExceed (files, fileList) {
      this.$message.warning(
        `当前限制选择 10 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length
        } 个文件`
      );
    },
    beforeRemove (file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },

    onSuccessUpload (res, file, fileList) {
      // console.log(res,'---')
      // console.log( this.fileList,' this.fileList---')
      this.fileLength++;
      // 这里需要根据你自己的接口返回数据格式和层级来自行修改
      if (res.data) {
        // 判断接口上传成功
        if (this.fileList.length < this.limit) {
          // 未超限时，把接口返回的图片url地址添加到fileList
          let datas = res.data;
          datas.name = res.data.fileName;
          this.fileList.push(datas);
        }
      } else {
        // 判断接口上传失败
        this.syncElUpload();
        this.$refs.uploadRef.clearFiles();
        this.$message({ type: "error", message: res.msg });
      }
      if (this.fileLength === fileList.length) {
        this.isUploading = false;
      }
    },
    success (res) {
      console.log(res);
    },
  },
};
</script>
<style scoped>
.list-t {
  display: flex;
  justify-content: space-between;
  line-height: 30px;
}

.header {
  font-size: 16px;
  border-bottom: 1px solid #f5f5f5;
  margin-bottom: 10px;
  padding-bottom: 10px;
  display: flex;
  justify-content: space-between;
}

::v-deep .el-rate__icon {
  font-size: 30px;
}

.label-list {
  display: flex;
  justify-content: space-between;
}
</style>
